module.exports = __webpack_public_path__ + "static/media/debicheck.9fb6e3ba.png";